import type { BreadcrumbItem } from '@/components/Breadcrumbs/Breadcrumbs';
import { slugify } from '@/utils/string';
import { LINKS } from '@/constants/links';
import type { Category, SubCategory } from '../functions/utils';

export function useBreadcrumbs(category?: Category | SubCategory): BreadcrumbItem[] {
	if (!category) return [];

	const accumulatedPath: string[] = [];

	const breadcrumbs = category.path.map((path, index) => {
		accumulatedPath.push(slugify(path));
		return {
			title: path,
			to:
				index === 0
					? LINKS().gcssCategory(slugify(path))
					: LINKS().gcssSubCategory(accumulatedPath),
		};
	}) satisfies BreadcrumbItem[];

	breadcrumbs.unshift({
		title: '',
		to: LINKS().gcssHomepage,
	});

	return breadcrumbs;
}
